package songwritersnotebook.app.utils

import songwritersnotebook.app.data.Section
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.functions
import io.ktor.client.*
import kotlinx.serialization.json.*

class AiLyricService(private val httpClient: HttpClient) {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = true
    }

    private fun toNative(element: JsonElement): Any? {
        return when (element) {
            is JsonNull -> null
            is JsonObject -> element.mapValues { toNative(it.value) }
            is JsonArray -> element.map { toNative(it) }
            is JsonPrimitive -> {
                if (element.isString) element.content
                else element.booleanOrNull ?: element.longOrNull ?: element.doubleOrNull ?: element.content
            }
        }
    }

    suspend fun getLyricSuggestion(
        prompt: String,
        songTitle: String,
        songSections: List<Section>
    ): String {
        try {
            val functions = Firebase.functions("us-central1")
            val callable = functions.httpsCallable("getLyricSuggestion")
            
            val sectionsJson = json.encodeToJsonElement(songSections)
            val requestMap = mapOf(
                "prompt" to prompt,
                "songTitle" to songTitle,
                "songSections" to toNative(sectionsJson)
            )
            
            println("DEBUG_AI: Calling getLyricSuggestion with Map data")
            val result = callable.invoke(requestMap)
            return result.data<String>()

        } catch (e: Exception) {
            e.printStackTrace()
            val message = e.message ?: "Unknown error"
            return "Error: $message"
        }
    }
}
